import { Sizes } from '../../interfaces/Sizes';

export const imageSizesAsString = (sizes?: Sizes): string => {
  if (!sizes) return '';
  let imageSizes: string = `${sizes.base},`;
  if (sizes.sm) imageSizes += ` (min-width: 640px) ${sizes.sm}px,`;
  if (sizes.md) imageSizes += ` (min-width: 768px) ${sizes.md}px,`;
  if (sizes.lg) imageSizes += ` (min-width: 1024px) ${sizes.lg}px,`;
  if (sizes.xl) imageSizes += ` (min-width: 1280px) ${sizes.xl}px,`;
  if (sizes.xxl) imageSizes += ` (min-width: 1536px) ${sizes.xxl}px`;
  return imageSizes;
};
